
import Footer from './common/Footer.jsx'
import asicflow_logo from './assets/img/logos/asicflow_logo.png'

import { Link } from 'react-router-dom'

function PageWrapper(props){
    return (
        <div>
            { /*<section className="py-5"> */}
            <section>
            <div className="bg-danger py-2 d-none d-lg-block">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="d-flex">
                                <Link className="d-flex align-items-center text-decoration-none text-light" to="">
                                    <svg className="bi bi-phone" fill="currentColor" height={20} viewBox="0 0 16 16" width={20} xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
                                        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                                    </svg>
                                    <span className="ms-1">+32 496 03 19 94 </span>
                                </Link>
                                <Link className="d-flex align-items-center ms-lg-4 text-decoration-none text-light" to="">
                                    <svg className="bi bi-envelope" fill="currentColor" height={20} viewBox="0 0 16 16" width={20} xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                                    </svg>
                                    <span className="ms-2">onur.ates@gmx.com</span>
                                </Link>
                            </div>
                        </div>
                        <div className="col">
                            <div className="d-flex justify-content-end">
                                <a className="text-light" href="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gitlab" viewBox="0 0 16 16">
                                    <path d="m15.734 6.1-.022-.058L13.534.358a.57.57 0 0 0-.563-.356.6.6 0 0 0-.328.122.6.6 0 0 0-.193.294l-1.47 4.499H5.025l-1.47-4.5A.572.572 0 0 0 2.47.358L.289 6.04l-.022.057A4.044 4.044 0 0 0 1.61 10.77l.007.006.02.014 3.318 2.485 1.64 1.242 1 .755a.67.67 0 0 0 .814 0l1-.755 1.64-1.242 3.338-2.5.009-.007a4.05 4.05 0 0 0 1.34-4.668Z"/>
                                </svg>
                                </a>
                                <a className="text-light ms-3" href="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                                    </svg>
                                </a>
                                    <a className="text-light ms-3" href="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                                        <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <nav className="navbar navbar-expand-lg bg-light">
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img 
                        alt="AsicFlow"
                        className="img-fluid"
                        height=""
                        src={asicflow_logo}
                        width={200}
                        />
                    </Link>
                    <button
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        className="navbar-toggler"
                        data-bs-target="#navbarSupportedContent"
                        data-bs-toggle="collapse"
                        type="button"
                    >
                    <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto my-2 my-md-0 fw-bold">
                            <li className="nav-item ms-md-4">
                                <Link className="nav-link" to="/news">
                                News
                                </Link>
                            </li>
                            <li className="nav-item ms-md-4">
                                <Link className="nav-link" to="/blog">
                                Blog
                                </Link>
                            </li>
                            <li className="nav-item ms-md-4">
                                <Link className="nav-link" to="/tools">
                                Tools
                                </Link>
                            </li>
                            <li className="nav-item ms-md-4">
                                <Link className="nav-link" to="/about">
                                About
                                </Link>
                            </li>
                            <li className="nav-item ms-md-4">
                                <Link className="nav-link" to="/contact">
                                Contact
                                </Link>
                            </li>
                            <li className="nav-item ms-md-4 d-none d-md-block">
                                <Link className="btn btn-primary" to="/login">
                                Login or Signup
                                </Link>
                            </li>
                        </ul> 
                    </div>
                </div>
            </nav>
            </section>
           {/*<Hero/>
            <Products/>
            <Card1/>
            <About/>
            <Testimonials/>
            <FollowUs/>
            <Footer/>*/}
            {props.children}
            <Footer/>
        </div>
    )
}

export default PageWrapper